import { useState, useEffect } from "react";

export function useInView(ref, options = {}) {

    const [isIntersecting, setIntersecting] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            setIntersecting(entry.isIntersecting);
        }, options);

        if (ref.current) observer.observe(ref.current);

        return () => observer.disconnect();
    }, [ref, options]);

    return isIntersecting;
}